import {FieldValues} from 'react-hook-form';
import {ZodType} from 'zod';
import {createContext, ReactNode, useContext} from 'react';

export type SchemaContext<TFieldValues extends FieldValues = FieldValues> = {
  schema: ZodType<TFieldValues>;
};

const SchemaContext = createContext<SchemaContext | null>(null);
export const useSchemaContext = <TFieldValues extends FieldValues>() =>
  useContext(SchemaContext) as SchemaContext<TFieldValues>;

export type SchemaProviderProps<TFieldValues extends FieldValues> =
  SchemaContext<TFieldValues> & {
    children: ReactNode;
  };
export const SchemaProvider = <TFieldValues extends FieldValues>(
  props: SchemaProviderProps<TFieldValues>
) => {
  const {children, ...value} = props;

  return (
    <SchemaContext.Provider value={value}>{children}</SchemaContext.Provider>
  );
};